import mietendeckel from '../../fields/cases/mietendeckel';

export const MUTATION_UPDATE_MD_CASE = /* GraphQL */ `
	mutation($input: MietendeckelCaseUpdate!, $id: String!) {
		updateMietendeckelCase(input: $input, id: $id) {
			${mietendeckel}
		}
	}
`;
